async function initAllModules() {
    const moduleElements = document.querySelectorAll("[data-module]");
    const loadedModules = new Set();

    // ✅ URL absolue fournie par WordPress — aucun problème de chemin relatif
    const modulesBase = window.ThemeConfig?.modulesUrl ?? './modules/';

    const promises = Array.from(moduleElements).map(async (element) => {
        const moduleName = element.getAttribute("data-module");

        if (!moduleName || loadedModules.has(moduleName)) return;
        loadedModules.add(moduleName);

        try {
            const module = await import(`${modulesBase}${moduleName}.js`);

            if (module && typeof module.init === "function") {
                module.init();
                // console.log(`Module ${moduleName} chargé`);
            } else {
                console.warn(`Le module ${moduleName} n'a pas de fonction init.`);
            }
        } catch (error) {
            console.error(`Erreur de chargement du module ${moduleName}:`, error);
        }
    });

    await Promise.all(promises);
    // console.log("Tous les modules ont été chargés et initialisés.");
}

document.addEventListener("DOMContentLoaded", () => {
    initAllModules();
});